export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  export const setFormData = (form, removeFromStart = null) => {
    let data = {};

    form.querySelectorAll("input, select, textarea").forEach((element) => {
        let id;

        if(removeFromStart){
            let split = (element.id).split(removeFromStart);
            if(split.length > 1){
                id = split[1];
            }
            else{
                id = split[0]
            }
        }
        else{
            id = element.id;
        }

        let isNonString = element.getAttribute("data-type-value");
        let parseFunction;

        if(isNonString){
            parseFunction = getParseFunction(isNonString);
        }

        if(element.tagName == "INPUT" && element.type != "file" && element.type != "checkbox" && element.id != "service_station_name" && element.id != "name"){
            data[id] = isNonString? parseFunction(element.value.trim().toLowerCase()) : element.value.trim().toLowerCase();
        }
        else if(element.id == "service_station_name" || element.id == "name"){
            data[id] = element.value.trim();

        }
        else if(element.tagName == "TEXTAREA"){
            data[id] = element.value.trim().toLowerCase()
        }
        else if(element.tagName == "INPUT" && element.type == "checkbox"){
            data[id] = element.checked;
        }
        else if(element.tagName == "SELECT"){
            data[id] = isNonString? parseFunction(element.value.toLowerCase()) : element.value.toLowerCase();

        }
    })

    return data;
  }


  function getParseFunction(type){
    if(type == "int"){
        return parseInt;
    }
    else if(type == "float"){
        return parseFloat;
    }
  }



export function loadImage(file) {
    return new Promise((resolve, reject) => {
        let url = URL.createObjectURL(file);

        const img = new Image();
        img.addEventListener('load', () => {
            URL.revokeObjectURL(url);
            resolve(img);
        });
        img.addEventListener('error', reject);
        img.src = url;
    });
}